import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { languageCodeCsvZodSchema } from "@@/shared/translations/language-code";
import {
    asTranslatableValue,
    requiredTranslatableZodSchema,
} from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { pageBlockZodSchema } from "../page-blocks/page-block";
import { pageBlockIdZodSchema } from "../page-blocks/page-block-id";
import { pageIdZodSchema } from "../page-id";
import { pageSlugZodSchema } from "../page-slug";

const pageCreateCommandZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("PAGE_CREATE_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    title: requiredTranslatableZodSchema,
    slug: pageSlugZodSchema,
    pageId: pageIdZodSchema,
    categories: z.record(z.string(), z.boolean()).optional(),
    tags: z.record(z.string(), z.boolean()).optional(),
    areas: z.record(z.string(), z.boolean()).optional(),
    blocks: z.record(pageBlockIdZodSchema, pageBlockZodSchema), // todo: add page block zod schemas
    blockSortOrder: z.array(pageBlockIdZodSchema),
    ownerId: providerIdZodSchema.optional(),
    languageCodeCsv: languageCodeCsvZodSchema,
});

type PageCreateCommand = z.infer<typeof pageCreateCommandZodSchema>;

type PageCreateCommandFactoryParams = Except<
    PageCreateCommand,
    "_id" | "_type" | "_createdAt"
>;
const pageCreateCommandFactory = (
    params: PageCreateCommandFactoryParams,
): PageCreateCommand => {
    return {
        ...params,
        _id: generateId("page_create_command__"),
        _type: "PAGE_CREATE_COMMAND",
        _createdAt: nowIsoAndUnix(),
        title: asTranslatableValue(params.title),
    };
};

export { pageCreateCommandFactory, pageCreateCommandZodSchema };
export type { PageCreateCommand, PageCreateCommandFactoryParams };
